
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rollers/concealed",
      function () {
        return require("private-next-pages/rollers/concealed/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rollers/concealed"])
      });
    }
  